import { render, staticRenderFns } from "./send.vue?vue&type=template&id=5c1acd4c&scoped=true&"
import script from "./send.vue?vue&type=script&lang=js&"
export * from "./send.vue?vue&type=script&lang=js&"
import style0 from "./send.vue?vue&type=style&index=0&id=5c1acd4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1acd4c",
  null
  
)

export default component.exports